import PropTypes from 'prop-types';

import {v4 as uuidv4} from 'uuid';

import * as cliparts from 'assets/cliparts';
import {fabric} from 'fabric';

import {isCustom, limitReached, setLastObjectActive} from '../canvas-helper';

export const getSize = (name) => {
    switch (name) {
    case 'futbol':
        return 30;

    default:
        return 40;
    }
};

const Clipart = function ({canvas, fill, clipart}) {
    canvas.on({
        'mouse:down': (o) => {
            if (limitReached(canvas)) {
                return;
            }

            if (canvas.getActiveObject()) {
                if (isCustom(canvas.getActiveObject())) {
                    return;
                }

                canvas.discardActiveObject();
            }

            fabric.loadSVGFromString(cliparts[clipart], (loaded) => {
                let pointer = canvas.getPointer(o.e);
                let img = fabric.util.groupSVGElements(loaded);
                img.scaleToWidth(getSize(clipart));
                img.originX = 'center';
                img.originY = 'center';

                if (img.item) {
                    img.item(0).set('fill', fill === '#ffffff' ? '#000000' : '#ffffff');
                    img.item(1).set('fill', fill);
                } else {
                    img.set('fill', fill);
                }

                const group = new fabric.Group([img], {
                    custom: {
                        type: 'clipart',
                        clipart,
                        id: uuidv4()
                    },
                    left: pointer.x,
                    top: pointer.y,
                    hasBorders: false,
                    hasControls: false,
                });

                canvas.add(group);
                setLastObjectActive(canvas);
            });
        },
    });
};

Clipart.propTypes = {
    canvas: PropTypes.object.isRequired
};

export default Clipart;
